// extracted by mini-css-extract-plugin
module.exports = {"text":"AuthoriseAccountsModal_text__iB9FT","subtitle":"AuthoriseAccountsModal_subtitle__3M6K7"};